import { localStorageItemKeys } from '~constants/local-storage-items'
import type { GuidedTourListItem } from '../content/guided-tours-list'

// A full load guarantees a fresh tour instance, even when already on the start path.
export function startGuidedTour(tour: GuidedTourListItem) {
  localStorage.setItem(localStorageItemKeys.triggeredGuidedTour, tour.id)
  localStorage.removeItem(localStorageItemKeys.guidedTourInitialStepIndex)
  window.location.assign(tour.tourStartLink)
}
